import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';


@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService) {}

    // DKM-5066 Clara: eski hâli
    // getData(control: any) {
    // DKM-5456 Cedric: eski hâli
    // getData(control: any, turu: number | null = null) {
    //         const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity + '?VezneTuru=Y');
    getData(control: any, turu: number | null = null, tumVezneler = false) {
            // DKM-5456 Cedric: tumVezneler → yetkili/aktif süzgeci yok (Forms RC_VEZNE gibi belediyenin tüm vezneleri)
            // DKM-5456 Cedric (22.10 dtokgoz: pasifler çıkarılsın): eski hâli
            // const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity + (tumVezneler ? '' : '?VezneTuru=Y'));
            // tumVezneler → ?AktifEh=E: GysVezneBs.BsPredicate yalnız AKTIF_EH='E' süzer, kullanıcı yetkisi süzgeci yok
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity + (tumVezneler ? '?AktifEh=E' : '?VezneTuru=Y'));
            dataSource.select(['VezneAd','Kod','VezneKod','VezneGorev']);
            // DKM-5066 Clara: tür verilmişse (tahsilat girişi: 1) popup listesi de o türle süzülür
            if (turu != null) dataSource.filter(['Turu', '=', turu]);
            return dataSource;
    }

}
